import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import * as moment from 'moment';
import { AiOutlineSearch } from "react-icons/ai";
import axioPath from '../../../../../api/axioPath';
import Spinner from '../../../../components/Spinner'
import { Table } from 'reactstrap';
import Pagination from '@material-ui/lab/Pagination';
import { SearchWrapper } from '../DashBoard/dashBoardStyled'
import AlertModal from 'web/components/AlertModal';

import Button from 'web/components/Button';
import SearchTypeahead from './SearchTypeahead';
import CsvDownloader from 'react-csv-downloader';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import { Heading } from 'web/pages/private/Admin/adminStyled'
import { TableWrapper } from './userInfoStyled'
import { AddExistingPromoCodeforUserApi } from '../../../../../redux/actions/admin';

const UsersList = ({ togglePage, fetchMyAPI, apiData, tableData, updateUsersPromoCodeList, updateUsersPromoCodeTableData, updatePromoCodeStatus, updateNewPromoCodeListforUserFromUsersListPage }) => {
    const buttonStyle = { background: 'linear-gradient(to bottom, #61b01f 0%,#27911b 100%)', color: 'white', whiteSpace: 'nowrap', border: 0, borderRadius: '5px', padding: '5px 15px', margin: '2px', cursor: 'pointer' }
    let dispatch = useDispatch()
    let history = useHistory()
    const token = localStorage.getItem("token")
    const loaderVisible = useSelector(state => state.appReducer.loaderVisible);
    const [dataList, setDataList] = useState([])
    const [finalData, setFinalData] = useState([])
    const [tableSearch, setTableSearch] = useState('')
    const [page, setPage] = useState(1);
    const [csvData, setCsvData] = useState([])
    const [pageCount, setPageCount] = useState(0);
    const [searchDataList, setSearchDataList] = useState([]);
    const [modal, setModal] = useState(false);
    const [modalContent, setModalContent] = useState('');
    const [alertType, setAlertType] = useState('')
    const toggleModal = () => setModal(!modal);
    const [searchedUser, setSearchedUser] = useState({ name: '', email: '' })
    const [countData, setcountData] = useState(0);

    let headerArr = [
        { title: 'Users', },
        { title: 'Used date ', },
        { title: 'Expiry Date', },
        { title: 'User Type', },
        { title: 'Status', }
    ];

    useEffect(() => {
        initialDataSet();
    }, [apiData]);

    const initialDataSet = () => {
        if (apiData.length > 0) {
            setDataList(apiData)
            setSearchDataList(apiData)
            setcountData(apiData?.length)
            let pageData = JSON.parse(JSON.stringify(apiData))
            let csvData = JSON.parse(JSON.stringify(apiData))
            //set data for csv export
            setCSVDate(csvData.splice(page * 10 - 10, 10))
            setFinalData(pageData.splice(page * 10 - 10, 10))

            if (apiData.length % 10 === 0) {
                setPageCount(apiData.length / 10)
            } else {
                setPageCount(Math.trunc(apiData.length / 10) + 1)
            }
            setTableSearch('')
        }
    };

    const handleChange = (event, value) => {
        setPage(value);
        let dataListtemp = JSON.parse(JSON.stringify(searchDataList))
        let pageData = JSON.parse(JSON.stringify(dataListtemp))
        setFinalData(pageData.splice(value * 10 - 10, 10))
    };

    const handleSearchChange = e => {
        e.preventDefault()
        setTableSearch(e.target.value)
        const search = e.target.value
        let dataListtemp = dataList.filter(value => {
            return (
                (value.users !== null && value.users.toString().toLowerCase().includes(search.toLowerCase())) ||
                (value.usedDate !== null && value.usedDate.toString().toLowerCase().includes(search.toLowerCase())) ||
                (value.benefitsExpire !== null && value.benefitsExpire.toString().toLowerCase().includes(search.toLowerCase())) ||
                (value.userType !== null && value.userType.toString().toLowerCase().includes(search.toLowerCase()))
            )
        }
        );
        setPage(1)
        if (dataListtemp.length % 10 === 0) {
            setPageCount(dataListtemp.length / 10)
        } else {
            setPageCount(Math.trunc(dataListtemp.length / 10) + 1)
        }
        let tempSearchData = JSON.parse(JSON.stringify(dataListtemp))
        setSearchDataList(tempSearchData)
        setFinalData(dataListtemp.splice(0, 10))
    }

    const handleIdClick = (e, index) => {
        e.preventDefault()
        const token = localStorage.getItem("token")
        let userId = finalData[index].userId
        axioPath.get(`/user/newPromoCode/userName/${userId}`, {
            headers: {
                Authorization: token,
            },
        }).then((response) => {
            if (response.data) {
                updateUsersPromoCodeList(response.data)
                updateUsersPromoCodeTableData(finalData[index])
            }
            togglePage('UsersPromoCodeList')
        }).catch((ex) => {
            setModalContent(ex.message)
            setModal(!modal)
        });
    }

    const addExistingCode = async (data, index) => {
        let content = {
            "generatePromoCode": tableData ? tableData[0].promoCode : '',
            "customerID": searchedUser.email
        }
        let response = await dispatch(AddExistingPromoCodeforUserApi(content))
        let searchStatus = { name: '', email: '' }
        setSearchedUser(searchStatus)
        if (response.status === 'SUCCESS') {
            fetchMyAPI()
            setModalContent('Promocode has been successfully added to the user.');
            setAlertType('createPromoCode')
            toggleModal();
        } else {
            if (response.statusCode === 401) {
                history.push('./sign-in')
                window.location.reload(false);
            } else {
                setModalContent(response.message);
                toggleModal();
            }
        }
    }

    const columns = [
        { id: 'Users', displayName: 'Users' },
        { id: 'Email', displayName: 'Email' },
        { id: 'UsedDate', displayName: 'UsedDate' },
        { id: 'ExpiryDate', displayName: 'Expiry Date' },
        { id: 'UserType', displayName: 'UserType' },
        { id: 'Status', displayName: 'Status' },
    ]

    const setCSVDate = (dataList) => {
        let tempCsvData = dataList.map(items => {
            return ({
                Users: items?.users,
                Email: items?.email,
                UsedDate: moment(items?.usedDate).format("MM/DD/YYYY"),
                ExpiryDate: moment(items?.benefitsExpire).format("MM/DD/YYYY"),
                UserType: items?.userType?.replaceAll(",", " "),
                Status: items?.active ? 'Active' : 'Inactive'
            })
        })
        setCsvData(tempCsvData.flat())
    }

    return (
        <>
            <TableWrapper>
                {loaderVisible && <Spinner />}
                <Heading>
                    <div className='promo-code-user-list-header'>
                        <div className='section-one'>
                            <div className='info-section'>
                                <h3>{tableData && tableData[0].promoCode} ({countData}/
                                    {tableData && tableData[0].limitUsageCount !== null ? tableData[0].limitUsageCount : 0} Used)</h3>
                                <h3>Provides free subscription to the users
                                    {tableData[0].timeSpanForBenefits !== null && ` for ${tableData[0].timeSpanForBenefits.number} `}
                                    {tableData[0].timeSpanForBenefits !== null && `${tableData[0].timeSpanForBenefits.timeDMY}(s)`}</h3>
                            </div>
                            <SearchWrapper>
                                <input type="text" placeholder='Search' value={tableSearch}
                                    onChange={handleSearchChange} />
                                <AiOutlineSearch />
                            </SearchWrapper>
                        </div>
                        <div className='section-two'>
                            <div className='action-section'>
                                <div className='d-flex'>
                                    <div>
                                        <p>Start Date</p>
                                        <p>{tableData && tableData.length > 0 && tableData[0].applyStartDate ? moment(tableData[0].applyStartDate).format("MM/DD/YYYY") : ''}</p>
                                    </div>
                                    <div style={{ marginLeft: '20px' }}>
                                        <p>End Date</p>
                                        <p>{tableData && tableData.length > 0 && tableData[0].applyEndDate ? moment(tableData[0].applyEndDate).format("MM/DD/YYYY") : ''}</p>
                                    </div>
                                </div>
                                <div className='promo-actions'>
                                    <p>Apply Promo Code to User</p>
                                    <div style={{ display: 'flex' }}>
                                        <SearchTypeahead
                                            placeholder='Search User'
                                            focusOnShow={false}
                                            filterBy="title"
                                            title={searchedUser.name}
                                            pageType="PostInventory"
                                            pageName="Dashboard"
                                            containerStyle="makeSearch"
                                            color="#074269"
                                            backgroundColor="#01b3ff"
                                            setUserNameValue={(userName, email) => setSearchedUser({ name: userName, email: email })}
                                        />
                                        <Button
                                            type='app-green-button submitBtn'
                                            handleClick={addExistingCode}
                                            disabled={searchedUser.name === ''}
                                        >
                                            Apply Code
                                        </Button>
                                    </div>
                                </div>
                            </div>

                            <div style={{ display: 'flex', marginTop: 15, justifyContent: 'space-between' }}>
                                <CsvDownloader
                                    style={{ marginTop: 25 }}
                                    filename="Promo Code List"
                                    columns={columns}
                                    datas={csvData}>
                                    <button
                                        style={buttonStyle}>
                                        Export
                                    </button>
                                </CsvDownloader>
                                <FormControlLabel
                                    style={{ marginRight: 0 }}
                                    labelPlacement="top"
                                    label={tableData && tableData[0].isActive ? 'Active' : 'Inactive'}
                                    control={
                                        <Switch
                                            checked={tableData && tableData[0].isActive}
                                            onClick={() => updatePromoCodeStatus(tableData && tableData[0].id, tableData && tableData[0].state, token)}
                                            name="checkedB"
                                            color="primary"
                                        />
                                    }
                                />
                            </div>
                        </div>
                    </div>
                </Heading>
                <Table responsive>
                    <thead>
                        <tr>
                            {headerArr.map((items, index) => (
                                <th key={index}>{items.title}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {
                            finalData.map((items, index) => (
                                <tr key={index}>
                                    <td><a style={{ color: '#00b2fe', cursor: 'pointer' }}
                                        onClick={e => handleIdClick(e, index)}
                                    >{items.users}</a></td>
                                    <td>{moment(items.usedDate).format("MM/DD/YYYY")}</td>
                                    <td>{moment(items.benefitsExpire).format("MM/DD/YYYY")}</td>
                                    <td>{items.userType}</td>
                                    <td>{items.active ? 'Active' : 'Inactive'}</td>
                                </tr>
                            ))}
                    </tbody>
                </Table>
                {finalData.length === 0 &&
                    <p style={{ position: 'absolute', width: '100%', textAlign: 'center' }}>No records found</p>
                }
                {finalData.length !== 0 && dataList.length !== 0 && <Pagination count={pageCount}
                    page={page}
                    onChange={handleChange} />}
            </TableWrapper>
            <Button
                type='app-green-button submitBtn'
                handleClick={() => togglePage('PromoCode')}
            >
                Back
            </Button>
            <AlertModal
                isOpen={modal}
                toggle={toggleModal}
                title=''
                content={modalContent}
                alertType={alertType}
                callBackAlert={() => {
                    updateNewPromoCodeListforUserFromUsersListPage(tableData[0].id)
                }}
            />
        </>

    )
};

export default UsersList;